export enum CalendarViewType {
    Day = "timeGridDay",
    Week = "timeGridWeek",
    Month = "dayGridMonth"
}

export type CalendarViewOption = {
    value: CalendarViewType
    label: string
}

export const DEFAULT_CALENDAR_VIEW = CalendarViewType.Week

const CALENDAR_VIEW_VALUES = new Set<string>(Object.values(CalendarViewType))

export function isCalendarViewType(view: string): view is CalendarViewType {
    return CALENDAR_VIEW_VALUES.has(view)
}

export function toCalendarViewType(view: string): CalendarViewType {
    return isCalendarViewType(view) ? view : DEFAULT_CALENDAR_VIEW
}

export function isDayView(view: string): boolean {
    return view === CalendarViewType.Day
}

export function isMonthView(view: string): boolean {
    return view === CalendarViewType.Month
}

export function findViewOption(
    viewType: CalendarViewType,
    options: CalendarViewOption[]
): CalendarViewOption | undefined {
    return options.find((option) => option.value === viewType)
}
